var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { BasicOptionCheckState } from '../../../../../classes/learnware/LearnwareEnums';
let CheckInEditMode = class CheckInEditMode extends React.PureComponent {
    render() {
        const { option } = this.props;
        const checkState = option.shouldBeSelected ? BasicOptionCheckState.Correct : BasicOptionCheckState.Default;
        const question = option.question;
        const circleOrSquare = question.choiceInfo.hasMultipleCorrectOptions ? 'square' : 'circle';
        let checkIcon;
        let checkColor;
        if (checkState === BasicOptionCheckState.Default) {
            checkIcon = `fa-${circleOrSquare}`;
            checkColor = 'rgba(153, 153, 153, 0.5)';
        }
        else if (checkState === BasicOptionCheckState.Correct) {
            checkIcon = `fa-check-${circleOrSquare}`;
            checkColor = '#9CBF52';
        }
        else if (checkState === BasicOptionCheckState.Wrong) {
            checkIcon = 'fa-times';
            checkColor = '#A94442';
        }
        return (React.createElement("div", { style: { position: 'absolute', display: 'flex', marginLeft: 10, marginTop: 5 } },
            React.createElement("i", { className: `fa ${checkIcon}`, onClick: action(() => (option.shouldBeSelected = !option.shouldBeSelected)), style: {
                    flex: '0 1 auto',
                    color: checkColor,
                    cursor: 'pointer',
                    opacity: 1,
                    fontSize: 22,
                    marginRight: 10,
                } })));
    }
};
CheckInEditMode = __decorate([
    observer
], CheckInEditMode);
export { CheckInEditMode };
